export { default as SearchErrorBoundary } from './search-error-boundary';
